// Default images by venue type
// Cafe image is the existing default, others are type-specific

const DEFAULT_IMAGES = {
  cafe: "https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=800",
  pub: "https://images.unsplash.com/photo-1771101961412-48ae1cf6ef88?w=800",
  library: "https://images.unsplash.com/photo-1758885698366-47d44c6ec6ba?w=800",
  hub: "https://images.unsplash.com/photo-1758711516684-e7a87556015e?w=800",
  hotel: "https://images.unsplash.com/photo-1758448500688-3ababa93fd67?w=800",
  other: "https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=800"
};

// Placeholder for images that were too large
const PLACEHOLDER_IMAGE = "https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=800";

export function getDefaultImage(venueType, size = 800) {
  const baseUrl = DEFAULT_IMAGES[venueType] || DEFAULT_IMAGES.cafe;
  // Replace the width parameter if it exists, otherwise use the base URL
  return baseUrl.replace(/\?w=\d+/, `?w=${size}`);
}

export function getVenueImage(venue, size = 800) {
  // If venue has images, use the first one (but check for placeholder)
  if (venue?.images?.[0]) {
    const firstImage = venue.images[0];
    // If it's a placeholder path, use default instead
    if (firstImage === "/placeholder-image-too-large.jpg" || firstImage.includes("placeholder")) {
      return getDefaultImage(venue?.venue_type, size);
    }
    return firstImage;
  }
  // Otherwise return the default based on venue type
  return getDefaultImage(venue?.venue_type, size);
}

export default DEFAULT_IMAGES;
